import React from 'react';
import './Button.scss';

export default function Button({ label, varian, width, icon, onClick, active, disabled }) {

  const classButton = `myBtn ${varian} ${active ? 'active' : ''}`;

  const Icon = () => {
    if (icon) {
      return <img src={icon} alt="icon" />;
    }
    return false;
  }
  if (disabled) {
    return (
      <div className={classButton} style={{ cursor:'default', color:'#999',width }}>
        <Icon />
        {label}
      </div>
    )
  }
  return (
    <div className={classButton} style={{ width }} onClick={onClick}>
      <Icon />
      {label}
    </div>
  )
}
